import React, { Component } from 'react';

import Highlight from 'common/developers/docs/api/Highlight';

import APIDocsBlock from '../APIDocsBlock';
import APIDocsTable from '../APIDocsTable';

export default class APIDocsUserObjectBlock extends Component {
  createdAt = new Date();

  render() {
    return (
      <APIDocsBlock>
        <div>
          <div className="heading">The user object</div>
          <APIDocsTable
            title="Attributes"
            rows={[
              {
                description: 'A unique identifier for the user.',
                heading: 'id',
                subheading: 'string',
              },
              {
                description:
                  "Name used in place of the user's actual name in anonymized boards. This field can be null if user has not previously engaged with the company.",
                heading: 'alias',
                subheading: 'string',
              },
              {
                description: "Link to the user's avatar image.",
                heading: 'avatarURL',
                subheading: 'string',
              },
              {
                description: 'A list of companies the user is associated with.',
                heading: 'companies',
                subheading: 'array',
              },
              {
                description: 'Time at which the user was created, in ISO 8601 format.',
                heading: 'created',
                subheading: 'string',
              },
              {
                description: 'Any custom fields associated with the user.',
                heading: 'customFields',
                subheading: 'object',
              },
              {
                description:
                  "The user's email. This field can be null, for example when you create a new user by voting on behalf of them.",
                heading: 'email',
                subheading: 'string',
              },
              {
                description: 'Whether or not the user is a Canny admin.',
                heading: 'isAdmin',
                subheading: 'boolean',
              },
              {
                description:
                  'Time at which the user interacted with your company for the last time, in ISO 8601 format.',
                heading: 'lastActivity',
                subheading: 'string',
              },
              {
                description: "The user's name.",
                heading: 'name',
                subheading: 'string',
              },
              {
                description: "The URL of the user's profile.",
                heading: 'url',
                subheading: 'string',
              },
              {
                description:
                  "The user's unique identifier in your application. This field can be null. We only have this data if the user was authenticated via single sign-on, or if it was added via API.",
                heading: 'userID',
                subheading: 'string',
              },
            ]}
          />
        </div>
        <div>
          <div className="text">Example user object:</div>
          <Highlight lang="json">
            {`{
  "id": "553c3ef8b8cdcd1501ba123a",
  "alias": "Green Fish",
  "avatarURL": "https://canny.io/images/a3db0133d1e7d9122832b67b2c4caaaa.jpg",
  "companies": [{
    "created": "2020-01-23T04:56:07.890Z",
    "customFields": {
      "field1": "value1",
      "field2": "value2"
    },
    "id": "company123",
    "monthlySpend": 500.00,
    "name": "company name"
  }],
  "created": "${this.createdAt.toISOString()}",
  "customFields": {
    "field1": "value1",
    "field2": "value2"
  },
  "email": "test@test.test",
  "isAdmin": false,
  "lastActivity": "${this.createdAt.toISOString()}",
  "name": "Sally Doe",
  "url": "https://your-company.canny.io/admin/users/sally-doe",
  "userID": "1234"
}`}
          </Highlight>
        </div>
      </APIDocsBlock>
    );
  }
}
